import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from 'styles/components/common/tooltip.scss';

class Tooltip extends Component {
  state = {
    visible: false
  };

  setVisibility = visible => {
    this.setState({ visible });
  };

  hide = () => {
    this.setVisibility(false);
  };

  makeDirectionClassName = direction => {
    switch (direction) {
      case 'left':
        return styles.left;
      case 'right':
        return styles.right;
      default:
        return '';
    }
  }

  show = () => {
    this.setVisibility(true);
  };

  render() {
    const { wrapperClassName, tooltipClassName, contentClassName, children, content, simple, direction, sponsored } = this.props;
    const { visible } = this.state;

    return (
      <div className={cn(styles.wrapper, wrapperClassName)} onMouseEnter={this.show} onMouseLeave={this.hide}>
        {children}
        {visible && (
          <div className={cn(styles.tooltip, { [styles.simpleTooltip]: simple, [styles.sponsored]: sponsored }, this.makeDirectionClassName(direction), tooltipClassName)}>
            <div className={cn(styles.content, contentClassName)}>{content}</div>
          </div>
        )}
      </div>
    );
  }
}

Tooltip.propTypes = {
  children: PropTypes.any.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired,
  wrapperClassName: PropTypes.string,
  tooltipClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  simple: PropTypes.bool
};

export default Tooltip;
